import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Banner from "./components/Banner";
import Planos from "./components/Planos";
import ControleNaPalma from "./components/ControleNaPalma";
import Comeceagora from "./components/ComeceAgora";
import OndeUsar from "./components/OndeUsar";
import NascemosParaFacilitar from "./components/NascemosParaFacilitar";
import TagVeloe from "./components/TagVeloe";
import { getComponent } from "../../store/ducks/component/actions";

const selector = state => ({
	component: state.component
});

export default function Parcerias() {
	const dispatch = useDispatch();
	const { component } = useSelector(selector);
	const { landingOrder, landingTitle } = component;

	useEffect(() => {
		dispatch(getComponent());
	}, [dispatch]);

	document.title = landingTitle;

	const pages = {
		landingHeader: <Banner />,
		landingDefaultPromo: <Planos />,
		landingSimpleSection: <ControleNaPalma />,
		landingStepperSection: <Comeceagora />,
		landingMapa: <OndeUsar />,
		landingDoubleSection: <NascemosParaFacilitar />,
		landingSecaoTagVeloe: <TagVeloe />
	};

	return landingOrder.map(({ value }) => pages[value]);
}
